import { atom } from 'jotai';

export const sliderValues = [
  {
    value: 0,
    label: '',
  },
  {
    value: 1,
    label: '',
  },
  {
    value: 2,
    label: '',
  },
  {
    value: 3,
    label: '',
  },
  {
    value: 4,
    label: '',
  },
  {
    value: 5,
    label: '',
  },
  {
    value: 6,
    label: '',
  },
  {
    value: 7,
    label: '',
  },
] as const;

export type ConfidenceScoreSliderValues =
  (typeof sliderValues)[number]['value'];
export const ConfidenceThresholdValues: readonly ConfidenceScoreSliderValues[] =
  [0, 1, 2, 3, 4, 5, 6, 7] as const;

export const confidenceScoreFilterAtom = atom<
  ConfidenceScoreSliderValues | undefined
>(undefined);

export const binValues = [0, 1, 2, 3] as const;

export type BinValues = (typeof binValues)[number];

export const binFilterAtom = atom<BinValues | undefined>(undefined);

// Atom to disable dragging when confidence controls are being used
export const disableDragAtom = atom<boolean>(false);
